// Auto Id's
export const ID_CONTINUE_BUTTON = 'continue-button';
export const ID_OTP_VERIFICATION = 'otp-verification';
export const ID_PROFILE_IMAGE = 'userProfileImage';
export const ID_BACK_BUTTON = 'back-button';
export const ID_CLOSE_ACCOUNT_POPUP = 'close-account-popup';
export const ID_RESET_IDLE_SESSION = 'reset-idle-session';
export const ID_TOAST_SUCCESS = 'toast-success';
export const ID_TOAST_ERROR = 'toast-error';
export const ID_TRUSTED_DEVICE_PAGE = 'trusted-device-page';
export const ID_TRUSTED_DEVICE_BUTTON = 'trusted-device-button';
export const ID_TRUSTED_DEVICE_NO_THANKS_BUTTON = 'trusted-device-no-thanks-button';
